<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="user-tie"/>
          {{ $t('clientTrialExtendRequest') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <client-select class="mr-1 mb-1" :model="filterFormModel" attribute="client" @change="load"></client-select>
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">Client</div>
            <div class="col-lg-3">{{ $t('requestedBy') }}</div>
            <div class="col-lg-4">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <p><b>{{ $t('companyName') }}: </b>{{ item.client.companyName }}</p>
              <p><b>{{ $t('domain') }}: </b>{{ item.client.domain }}</p>
              <p><b>{{ $t('expireTime') }}: </b>{{ item.expireTime | moment('DD/MM/YY HH:mm:ss') }}</p>
              <p><b>{{ $t('numberOfDay') }}: </b>{{ item.numberOfDay }}</p>
            </div>
            <div class="col-lg-3">
              <p><b>{{ $t('user') }}: </b>{{ item.requestedBy.name }} ({{ item.requestedBy.email }})</p>
              <p v-if="item.requestNote"><b>{{ $t('requestNote') }}: </b>{{ item.requestNote }}</p>
            </div>
            <div class="col-lg-4">
              <p>
                <span v-if="item.rejectTime" class="badge badge-danger">{{ $t('rejected') }}</span>
                <span v-else-if="item.approveTime" class="badge badge-success">{{ $t('approved') }}</span>
                <span v-else class="badge badge-warning">{{ $t('waiting') }}</span>
              </p>
              <p><b>{{ $t('createTime') }}: </b>{{ item.createTime | moment('DD/MM/YY HH:mm:ss') }}</p>
              <p v-if="item.approveTime"><b>{{
                  $t('approveTime')
                }}: </b>{{ item.approveTime | moment('DD/MM/YY HH:mm:ss') }}</p>
              <p v-if="item.rejectTime"><b>{{ $t('rejectTime') }}: </b>{{
                  item.rejectTime | moment('DD/MM/YY HH:mm:ss')
                }}</p>
              <p v-if="item.processedBy"><b>{{
                  $t(item.approveTime ? 'approvedBy' : 'rejectedBy')
                }}: </b>{{ item.processedBy.name }} ({{ item.processedBy.email }})</p>
              <p v-if="item.processNote"><b>{{ $t('processNote') }}: </b>{{ item.processNote }}</p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="processPermission(item)">
                    <button @click="show(item, 'approve')" type="button" class="btn btn-sm btn-success mr-1">
                      <font-awesome-icon icon="check"/>&nbsp;{{ $t('approve') }}
                    </button>
                    <button @click="show(item, 'reject')" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="ban"/>&nbsp;{{ $t('reject') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus
             :title="$t(formModel.action === 'approve' ? 'approveTrialExtendRequest' : 'rejectTrialExtendRequest')">
      <template v-if="client">
        <p><b>{{ $t('companyName') }}: </b>{{ client.companyName }}</p>
        <p><b>{{ $t('domain') }}: </b>{{ client.domain }}</p>
        <p><b>{{ $t('expireTime') }}: </b>{{ client.expireTime | moment('DD/MM/YY HH:mm:ss') }}</p>
        <p><b>{{ $t('numberOfDay') }}: </b>{{ client.numberOfDay }}</p>
        <p><b>{{ $t('requestNote') }}: </b>{{ client.requestNote ? client.requestNote : $t('notUpdated') }}</p>
      </template>
      <form-textarea :label="$t('processNote')" attribute="processNote" :model="formModel" :errors="formErrors"
                     :placeholder="$t('processNotePlaceholder')"></form-textarea>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary float-right" @click="process">
          {{ $t(formModel.action) }}
        </button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import TimeRangePicker from "../../components/TimeRangePicker";
import ClientSelect from "@/components/ClientSelect";

export default {
  components: {
    ClientSelect,
    TimeRangePicker
  },
  mixins: [List],
  data: function () {
    return {
      service: '/client-trial-extend-request',
      autoLoad: true,
      defaultFilterFormModel: {
        keyword: null,
        client: null
      },
      showForm: false,
      formModel: {
        id: null,
        action: null,
        processNote: null
      },
      formErrors: [],
      client: null
    }
  },
  methods: {
    show(item, action) {
      this.client = item.client;
      this.client.numberOfDay = item.numberOfDay;
      this.client.requestNote = item.requestNote;
      this.formModel.id = item._id;
      this.formModel.action = action;
      this.formModel.processNote = null;
      this.showForm = true;
    },
    process() {
      let loader = this.$loading.show();
      this.$service.put('/client-trial-extend-request/process/' + this.formModel.id, this.formModel).then(response => {
        if (response && response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.action === 'approve' ? 'approveSuccess' : 'rejectSuccess'),
            icon: 'success',
            toast: true,
            timer: 5000,
            position: 'top-end'
          });
          this.showForm = false;
          this.load();
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.action === 'approve' ? 'approveFailed' : 'rejectFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    },
    processPermission(item) {
      if (item.approveTime || item.rejectTime) {
        return false
      }
      if (['owner', 'admin', 'operationsManager', 'manager'].includes(this.$store.state.user.role)) {
        return true
      }
      return false
    }
  },
  i18n: {
    messages: {
      en: {
        confirmTime: 'Confirm time',
        time: 'Time',
        approveConfirm: 'Are you sure to approve this request?',
        rejectConfirm: 'Are you sure to reject this request?',
        approveSuccess: 'Request approved!',
        rejectSuccess: 'Request rejected',
        approveFailed: 'Fail to approve request',
        rejectFailed: 'Fail to reject request',
        numberOfDay: 'Number of day to extend trial',
        requestNote: 'Request note',
        processNote: 'Process note',
        processNotePlaceholder: 'Input note for this decision',
        approveTrialExtendRequest: 'Approve trial extend request',
        rejectTrialExtendRequest: 'Reject trial extend request',
      },
      vi: {
        confirmTime: 'Thời gian xác nhận',
        time: 'Thời gian',
        approveConfirm: 'Bạn có chắc muốn duyệt yêu cầu này?',
        rejectConfirm: 'Bạn có chắc muốn từ chối yêu cầu này',
        approveSuccess: 'Duyệt thành công!',
        rejectSuccess: 'Từ chối thành công',
        approveFailed: 'Duyệt thất bại',
        rejectFailed: 'Từ chối thất bại',
        numberOfDay: 'Số ngày muốn gia hạn dùng thử',
        requestNote: 'Lý do xin gia hạn',
        processNote: 'Ghi chú của người duyệt',
        processNotePlaceholder: 'Ghi chú',
        approveTrialExtendRequest: 'Duyệt yêu cầu gia hạn dùng thử',
        rejectTrialExtendRequest: 'Từ chối yêu cầu gia hạn dùng thử'
      }
    }
  }
}
</script>